import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { useSubmitFeedbackMutation } from "@common/utils/graphql";
import { Body } from "@hypercard/web-components";
import { Phone } from "@phosphor-icons/react";

type Props = {
  prefix?: string;
};

export default function FeedbackDialog({ prefix }: Props) {
  const [feedback, setFeedback] = useState<string>("");
  const [submitFeedback, { loading }] = useSubmitFeedbackMutation();
  const handleSubmitFeedback = () => {
    submitFeedback({
      variables: {
        feedback: prefix ? `${prefix} ${feedback}` : feedback,
      },
    });
  };

  const resetFeedback = () => {
    setFeedback("");
  };
  return (
    <Dialog>
      <DialogTrigger onClick={resetFeedback}>
        <Button type="button" variant="outline" className="w-full">
          Send Feedback
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Send Feedback</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Your feedback helps us improve the Hypercard experience.
        </DialogDescription>

        {/* Text area */}
        <Textarea
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          className="mt-4 w-full"
          rows={1}
          placeholder="Add a note..."
        />

        {/* Call support box */}
        <div className="mt-6 flex w-full flex-col items-center rounded-lg bg-[#1B1B1B] p-8 text-center">
          <Body size="lg" weight="regular">
            Talk with Customer Support
          </Body>
          <Body size="sm" weight="regular" className="mt-2 text-white/70">
            Our 24/7 dedicated team will answer you immediately.
          </Body>
          <div className="mt-6 flex w-full items-center justify-center space-x-2 rounded-sm bg-black/30 py-3">
            <Phone className="size-4 text-white" />
            <Body size="sm" weight="medium">
              +1 (514) 570-5196
            </Body>
          </div>
        </div>

        <DialogFooter className="w-full">
          <DialogClose className="w-full">
            <Button
              type="button"
              variant="default"
              disabled={loading || !feedback}
              onClick={handleSubmitFeedback}
              className="w-full"
            >
              Submit
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
